const { Core, onPlyrLoad, Utils } = Global;
const { $replaceContent } = Utils;

customElements.define('video-player', class extends Core {
  elements = {
    $: ['player', 'video-template', 'video-wrapper'],
    HTML5Player: 'video'
  }

  propTypes = {
    'loop': Boolean,
    'inited': Boolean
  }
  
  render() {
    if (this.prop('inited')) {
      $replaceContent(this.$('video-wrapper'), this.$('video-template'));
    }
    onPlyrLoad(this._initPlayer.bind(this));
  }

  _initPlayer() {
    this.player = new Plyr(this.$player, { ratio: '16:9' });
    this.player.loop = this.prop('loop');

    // Ensure audio can play when user opens modal
    this.player.on('ready', () => {
      const html5 = this.$('HTML5Player');
      if (html5) {
        html5.muted = false;
        html5.removeAttribute('muted');
        html5.volume = 1;
        html5.setAttribute('playsinline', '');
      }

      const iframe = this.$player?.querySelector?.('iframe');
      if (iframe) {
        const allow = iframe.getAttribute('allow') || '';
        if (!/autoplay/.test(allow)) {
          iframe.setAttribute('allow', `${allow}; autoplay; fullscreen; picture-in-picture`);
        }
      }

      try {
        this.player.muted = false;
        this.player.volume = 1;
      } catch(e) {}
    });

    this.setAttribute('inited', '');
  }

  play() {
    this.player?.play();
  }

  pause() {
    this.player?.pause();
  }

  // ✅ new helper for unmuting externally
  unmute() {
    try {
      this.player.muted = false;
      this.player.volume = 1;
    } catch(e) {}

    const html5 = this.$('HTML5Player');
    if (html5) {
      html5.muted = false;
      html5.removeAttribute('muted');
      html5.volume = 1;
      html5.setAttribute('playsinline', '');
    }
  }

  get $player() {
    return this.$('player') || this.$('HTML5Player');
  }

  destroy() {
    this.player?.destroy?.();
  }
});
